import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterEvent,
} from '@angular/router';
import { Subscription } from 'rxjs';
import { CasesService } from 'src/app/core/services/cases.service';
import { UnitsService } from 'src/app/core/services/units.service';
import { UserService } from 'src/app/core/services/user.service';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';
import { IUnit } from 'src/app/modules/unit/interfaces/unit.interface';
import { CreateCaseComponent } from '../create-case/create-case.component';
import { CreateAlertComponent } from '../create-case/create-alert/create-alert.component';
import { AlertService } from 'src/app/modules/case-new-view/alert.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as XLSX from 'xlsx';
import { FilterCasesNewViewComponent } from './filter-cases-new-view/filter-cases-new-view.component';
import { AT14Services } from 'src/app/services/AT14.service';
import { SocketService } from 'src/app/core/services/socket.service';
import { IAlert } from 'src/app/components/malla/interfaces/IAlertInfo';

export interface IAlertaExcel {
  'TIPO DE PERSONA': string;
  IDENTIFICACION: string;
  APELLIDO: string;
  NOMBRE: string;
  TELEFONO: string;
  CORREO: string;
  CELULAR: string;
  CLIENTE: string;
  DOMICILIO: string;
  'TIPO REGISTRO': string;
  CANAL: string;
  INSTRUMENTO: string;
  DESCRIPCION: string;
  MONTO: string;
}

@Component({
  selector: 'case-header-new-view',
  templateUrl: './case-header-new-view.component.html',
  styleUrls: ['./case-header-new-view.component.scss'],
})
export class CaseHeaderNewViewComponent implements OnInit {
  @ViewChild('fileInput') fileInput: any;
  @ViewChild('filterCasesNewView')
  filterCasesNewView: FilterCasesNewViewComponent;
  @Input() view: string = 'Case';
  @Output() recharge = new EventEmitter();
  routerSuscription: Subscription;
  unitId!: string;
  caseTypes: ICaseType[] = [];
  filters = {};
  search = '';
  unit!: IUnit;
  searchTouch: boolean;
  users;
  loading = false;
  ci: string;
  alert: IAlert = null;
  urgenteActive = false;
  opcionActual = '';
  isGerente: boolean = false;
  constructor(
    private _snackbar: MatSnackBar,
    private readonly userService: UserService,
    private readonly router: Router,
    private route: ActivatedRoute,
    private readonly unitsService: UnitsService,
    private readonly dialog: MatDialog,
    private readonly casesService: CasesService,
    private readonly alertService: AlertService,
    private aT14Services: AT14Services,
    private socket: SocketService
  ) {
    this.isGerente = userService.isGerente();

    this.routerSuscription = this.router.events.subscribe(
      async (event: RouterEvent) => {
        if (event instanceof NavigationEnd) {
          this.unitId = route.snapshot.paramMap.get('id');
          this.getUnit();
          this.getCaseTypes();
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.routerSuscription?.unsubscribe();
  }

  ngOnInit() {
    this.alertService.mandaValorUrgente.subscribe({
      next: (value: boolean) => {
        this.urgenteActive = value;
        if (!this.urgenteActive) {
          this.opcionActual = '';
          this.alertService.filtroUrgentes.next({
            filter: {},
            option: undefined,
          });
        }
      },
    });
    this.casesService.filterDataRas.subscribe({
      next: (filters: any) => {
        if (filters.assigned == '') {
          delete filters.assigned;
        }
        this.filterData(filters);
      },
    });
  }

  getUnit() {
    this.loading = true;
    this.unitsService.getById(this.unitId).subscribe({
      next: (unit) => {
        this.loading = false;
        this.unit = unit;
      },
    });
  }

  findUser() {
    this.userService.getUsersByRole(this.caseTypes[0].role).subscribe({
      next: (users) => {
        this.users = users;
      },
    });
  }
  get canSee() {
    return this.userService.permissions?.seeCases;
  }
  get canCreate() {
    let permission = this.userService.permissions?.createCases;
    /* En caso de ser incidencia no mostrar crear */
    let isIncidencia = this.unit?.name == 'Incidencias' ? true : false;
    return permission && !isIncidencia;
  }
  get seeStrikes() {
    let permission = this.userService.permissions?.seeStrikes;
    return permission;
  }
  get seeArchived() {
    let permission = this.userService.permissions?.seeArchivedCases;
    /* En caso de ser incidencia no mostrar casos archivados */
    let isIncidencia = this.unit?.name == 'Incidencias' ? true : false;
    return permission && !isIncidencia;
  }

  getCaseTypes() {
    this.unitsService.getTypeCases(this.unitId).subscribe({
      next: (caseTypes) => {
        this.caseTypes = caseTypes;
        this.findUser();
        caseTypes.forEach((caseType) => {
          this.filters[caseType._id] = false;
        });
      },
    });
  }

  /** Filtros aplicados por el usuario (fecha y asignado; el tipo va siempre). */
  get filtrosActivos(): number {
    const f = this.filterCasesNewView?.form?.value || {};
    return (f.date ? 1 : 0) + (f.assigned ? 1 : 0);
  }

  filterData(filters = {}) {
    this.searchTouch = false;
    let filter = {
      caseType: this.caseTypes[0]._id,
      search: this.search,
    };
    filters['caseType'] = this.caseTypes[0]._id;

    if (this.filterCasesNewView.form.value.date) {
      filters['beging'] = this.filterCasesNewView.form.value.date.beging;
      filters['end'] = this.filterCasesNewView.form.value.date.end;
      filters['date'] = this.filterCasesNewView.form.value.date;
    }
    if (this.filterCasesNewView.form.value.assigned) {
      filters['assigned'] = this.filterCasesNewView.form.value.assigned;
    }

    if (this.search) {
      filters['search'] = this.search;
      filters['caseType'] = this.caseTypes[0]._id;
    }

    this.casesService.filterDataRasSearch.next(filters);
  }

  create() {
    if (this.unit.code == 'ALT') {
      this.dialog.open(CreateAlertComponent, {
        width: '770px',
        maxHeight: '80vh',
        data: { unit: this.unitId },
        disableClose: true,
        panelClass: 'class-ras-create',
      });
    } else {
      this.dialog.open(CreateCaseComponent, {
        width: '700px',
        maxHeight: '80vh',
        data: { unit: this.unitId },
        disableClose: true,
        panelClass: 'class-ras-create',
      });
    }
  }

  async onFileSelected_CargaMasivaAlertas() {
    const inputNode: any = document.querySelector('#file');
    const alertas = (await this.readExcel(
      inputNode.files[0],
      'Alertas'
    )) as IAlertaExcel[];
    const acciones = await this.readExcel(inputNode.files[0], 'Acciones');
    console.log(acciones);
    this.fileInput.nativeElement.value = '';
    const user_id = this.userService.currentUser._id;
    const unit_id = this.unitId;
    const alertaModels: Partial<IAlert>[] = [];
    for (let alerta of alertas)
      alertaModels.push(
        this.transformAlertaExcelToAlertaJson(alerta, user_id, unit_id)
      );
    console.log(alertaModels);
    const response = await this.alertService
      .carga(alertaModels, acciones)
      .toPromise();
    console.log(response);
    this._snackbar.open(`Alertas cargadas`, `Ok`, { duration: 1000 });
    this.recharge.emit('recharge');
  }

  transformAlertaExcelToAlertaJson(
    alertaExcel: IAlertaExcel,
    creator: string,
    unit: string
  ): Partial<IAlert> {
    const alerta: Partial<IAlert> = {
      creator,
      unit,
      tipo_de_persona: alertaExcel['TIPO DE PERSONA'],
      numero_de_identificacion: alertaExcel.IDENTIFICACION,
      apellido: alertaExcel.APELLIDO,
      nombre: alertaExcel.NOMBRE,
      oficina: 'Central',
      region: 'Este',
      telefono: alertaExcel.TELEFONO,
      correo: alertaExcel.CORREO,
      celular: alertaExcel.CELULAR,
      cliente: alertaExcel.CLIENTE,
      domicilio: alertaExcel.DOMICILIO,
      tipo_registro: alertaExcel['TIPO REGISTRO'],
      canal: alertaExcel.CANAL,
      instrumento: alertaExcel.INSTRUMENTO,
      descripcion: alertaExcel.DESCRIPCION,
      monto_salio: alertaExcel.MONTO,
    };
    return alerta;
  }

  readExcel(file: File, sheetName: string) {
    let fileReader = new FileReader();
    return new Promise((resolve, reject) => {
      fileReader.onload = (e) => {
        const f = XLSX.read(e.target.result, { type: 'binary' });
        const result = XLSX.utils.sheet_to_json(f.Sheets[sheetName], {
          raw: false,
          dateNF: 'dd/mm/yyyy',
        });
        resolve(result);
      };
      fileReader.onerror = reject;
      fileReader.readAsArrayBuffer(file);
    });
  }

  UpdateFile() {
    const input = document.createElement('input');
    input.type = 'file';

    input.click();
    input.onchange = (ev: any) => {
      const file: File = ev.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      this.aT14Services.uploadFileAT14(formData).subscribe({
        next: (url: any) => {
          console.log(url);
        },
      });
    };
  }

  receiveVuCase() {
    const alert: Partial<IAlert> = {
      creator: this.userService.currentUser._id,
      unit: this.unitId,
      tipo_de_persona: 'Natural',
      numero_de_identificacion: '123456789',
      apellido: 'Bertolini',
      nombre: 'Francisco',
      oficina: 'Central',
      region: 'Este',
      telefono: '+58123456789',
      correo: 'Bertolini@gmail.com',
      celular: '+58123456789',
      cliente: 'Cliente',
      domicilio: 'Domicilio',
      tipo_registro: 'Tipo Registro',
      canal: 'Cuenta',
      instrumento: 'Instrumento',
      descripcion: 'Alerta en proceso nueva creada',
      monto_salio: '1000',
      code: '03',
    };
    this.alertService.vuExample(alert).subscribe((res) => {
      console.log(res);
      this._snackbar.open(`Alertas en proceso creada`, `Ok`, {
        duration: 1000,
      });
    });
  }
  goToStrikeUser() {
    this.router.navigate([`/strike-user/${this.unitId}`]);
  }
  capitalizeString(str) {
    if (typeof str !== 'string' || str.length === 0) {
      return str; // Opcional: manejar cadenas vacías o no válidas
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  filterByOption(filter, option) {
    // La etiqueta del botón usa el mismo texto que el menú.
    const etiquetas = {
      'no Localizado': 'Cliente no Localizado',
      'Rechazada con cuenta': 'Rechazada Condicionada',
    };
    this.opcionActual = etiquetas[option] || this.capitalizeString(option);
    this.alertService.filtroUrgentes.next({ filter, option });
  }
  irALaVistaReportes() {
    this.router.navigate([`/reports/${this.unitId}`]);
  }
}
